import React from 'react';
import { Box, Button, Typography, Paper } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import BrandPlanningTab from '../../components/Brands/BrandPlanningTab';

const BrandCalendarPage = () => {
  const { brandId } = useParams();
  const navigate = useNavigate();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: '100%' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 2 }}>
        <Box>
          <Typography variant="h4" fontWeight={700}>
            Drop Calendar
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Manage launch windows, ship offsets, and milestone guardrails for each drop cycle.
          </Typography>
        </Box>
        <Button variant="outlined" onClick={() => navigate(`/brands/${brandId}`)}>
          Back to Planning Dashboard
        </Button>
      </Box>

      <Paper
        sx={{
          flexGrow: 1,
          minHeight: 0,
          overflow: 'hidden',
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
          bgcolor: 'background.paper',
          p: { xs: 2, md: 3 },
        }}
      >
        <BrandPlanningTab brandId={brandId} variant="calendarOnly" />
      </Paper>
    </Box>
  );
};

export default BrandCalendarPage;
